import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Material-UI
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
// Icons
import { X } from 'tabler-icons-react';
// Context
import { useTelegram } from './TelegramContext';

export default function EditarTelegram({ open, onClose }) {
    const { areasAtencion, chats, telegrams, selectionModel, putTelegram } = useTelegram();
    const [selectedChat, setSelectedChat] = useState('');
    const [selectedArea, setSelectedArea] = useState('');
    const [levels, setLevels] = useState({ one: false, two: false, three: false });

    const row = telegrams.find(t => t.id === selectionModel[0]);

    useEffect(() => {
        if (!open || !row) return;
        const chat = chats.find(c => c.title === row.nombreGrupo);
        setSelectedChat(chat?.id ?? '');
        const area = areasAtencion.find(a => a.nombre === row.areaAtencion);
        setSelectedArea(area?.id ?? '');
        setLevels({ one: row.nivel1, two: row.nivel2, three: row.nivel3 });
    }, [open, row, chats, areasAtencion]);

    const handleClose = () => {
        setSelectedChat('');
        setSelectedArea('');
        setLevels({ one: false, two: false, three: false });
        onClose();
    };

    const handleSave = async () => {
        const chat = chats.find(c => c.id === selectedChat);
        const ok = await putTelegram({
            codigo: row.codigo,
            idGrupo: selectedChat,
            nombreGrupo: chat?.title ?? row.nombreGrupo,
            codigoArea: selectedArea,
            nivel1: levels.one,
            nivel2: levels.two,
            nivel3: levels.three,
        });
        if (ok) handleClose();
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <div className="usuarios-modal">
                <div className="usuarios-modal-header">
                    <h2 className="usuarios-modal-title">Editar Telegram</h2>
                    <IconButton size="small" onClick={handleClose}><X size={18} strokeWidth={2} /></IconButton>
                </div>
                <div className="usuarios-modal-body">
                    <div className="telegram-form-grid">
                        <FormControl fullWidth>
                            <InputLabel>Área de atención</InputLabel>
                            <Select value={selectedArea} onChange={e => setSelectedArea(e.target.value)}>
                                {areasAtencion.map(item => (
                                    <MenuItem key={item.id} value={item.id}>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel>Grupo</InputLabel>
                            <Select value={selectedChat} onChange={e => setSelectedChat(e.target.value)}>
                                {chats.map(chat => (
                                    <MenuItem key={chat.id} value={chat.id}>{chat.title}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Niveles</FormLabel>
                        <FormGroup row>
                            {[['one', 1], ['two', 2], ['three', 3]].map(([key, n]) => (
                                <FormControlLabel
                                    key={key}
                                    control={<Checkbox checked={levels[key]} onChange={e => setLevels(l => ({ ...l, [key]: e.target.checked }))} />}
                                    label={`Nivel ${n}`}
                                />
                            ))}
                        </FormGroup>
                        <FormHelperText>Puede marcar más de uno</FormHelperText>
                    </FormControl>
                </div>
                <div className="usuarios-modal-footer">
                    <Button variant="outlined" className="usuarios-modal-cancel" onClick={handleClose}>Cancelar</Button>
                    <Button variant="contained" color="primary" className="usuarios-modal-submit" onClick={handleSave} disabled={!selectedArea || !selectedChat}>
                        Guardar
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

EditarTelegram.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
